import { IntlShape } from "react-intl";
import { IDateTimeBox, IMultiCheckbox, dateTimeUtils } from "cayo.ui";
import { PossibleValueItem, WeeklySchedule } from "@cayo/shared/api/types/cayo-graph";
import { IFormField } from "@cayo/shared/api/types/schema";
import messages from "./messages";
import { nameofFactory } from "@cayo/shared/utils/object";
import { weekDays } from "../DateTimeBox/pickerStrings";
import { formComponentTypes } from "../Form/renderers/form-renderers";

const weeklyNames = nameofFactory<WeeklySchedule>();

export const possibleWeekDays = weekDays.map<PossibleValueItem>((d) => ({
  name: d,
  value: d.toLowerCase(),
}));

const weeklyForm = (intl: IntlShape, schedule?: WeeklySchedule) => {
  const startTime = dateTimeUtils.convertUtcTimeToLocal(
    dateTimeUtils.extractTime(schedule?.startTime) || dateTimeUtils.convertTimeToUtc("00:00")
  );

  return {
    title: intl.formatMessage(messages.weekly),
    items: [
      {
        type: "datetimebox" as formComponentTypes,
        label: intl.formatMessage(messages.startTime),
        autoFocus: true,
        required: true,
        readOnly: schedule?.readОnly,
        editMode: "onlyTime",
        name: weeklyNames("startTime"),
        value: startTime,
      } as IDateTimeBox,
      {
        type: "mv.checkbox" as formComponentTypes,
        possibleValues: possibleWeekDays,
        label: intl.formatMessage(messages.selectWeekDaysTitle),
        required: true,
        disabled: schedule?.readОnly,
        name: weeklyNames("days"),
        value: schedule?.days,
        horizontal: true,
      } as IMultiCheckbox,
    ] as IFormField[],
  };
};

export default weeklyForm;
